module.exports = __webpack_public_path__ + "img/Floor002367-img5.dcceff57.jpg";